export default "__VITE_ASSET__CgWts0o7__"